import Img from '@core/components/Img';
import Route from '@core/components/Route';
import { RoutePath } from '@core/types/route';
import Container from '@mui/material/Container';
import { H3 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import { FC, memo } from 'react';

import { H2Gold } from '../../components/ColoredHeading';
import { SectionDark1 } from '../../components/ColoredSection';

const Pyramide: FC = () => (
  <SectionDark1>
    <H2Gold>Die Pyramide der Meisterschaft</H2Gold>

    <Img
      alt='Kriegersein Falko Zander - Graduierung-System'
      src='/img/kampfkunst-pyramide-meisterschaft.jpg'
      sx={{ borderRadius: '0.25rem', maxWidth: '100%' }}
    />

    <Container sx={{ marginY: '1.5rem' }}>
      <H3>Schülergrade S1-S4</H3>
      <Paragraph>
        Die ersten vier Schülergrade vermitteln zunächst die Grundlagen der Kampfkunst. Dabei geht
        es vor allem darum, die Körperstruktur zu verbessern, unnötige Bewegungen zu vermeiden und
        ein Fundament für das Zusammenspiel von Armen, Rücken, Becken und Beinen zu legen. Weiterhin
        werden Ängste durchgearbeitet und es entsteht ein besseres Verständnis für den eigenen
        Charakter.
      </Paragraph>
    </Container>

    <Container sx={{ marginY: '1.5rem' }}>
      <H3>Schülergrade S5-S8</H3>
      <Paragraph>
        Im Schwerpunkt steht die Entspannung der Arme und die weitere Durcharbeitung von Hüfte und
        Beinen. Zunehmend wird auch Selbstverteidigung unterrichtet, bis hin zur Arbeit gegen
        Waffen. Während sich der Körper entspannt und sich der Geist immer weiter öffnet, entsteht
        ein neuer freundlicher Mensch.
      </Paragraph>
    </Container>

    <Container sx={{ marginY: '1.5rem' }}>
      <H3>Meister-Kandidaten C1-C2</H3>
      <Paragraph>
        Jetzt geht es um die reine Kampfkunst und den Weg zur Meisterschaft. Feinste
        Körper-Durcharbeitung und höchste Sensitivität sind gefragt, um diese Grade zu bestehen.
      </Paragraph>
    </Container>

    <Container sx={{ marginY: '1.5rem' }}>
      <H3>Meister M3-M6</H3>
      <Paragraph>
        Mit dem Erreichen des ersten Meistergrads, hat der neue Meister das Prüfungsprogramm
        durchgearbeitet. In den weiteren Meistergraden wartet freie Forschung auf ihn. Ein Weg ins
        unendliche Universum. Der einzige Meister außerhalb von Russland ist{' '}
        <Route href={RoutePath.FalkoZander}>Falko Zander</Route>.
      </Paragraph>
    </Container>

    <Container sx={{ marginY: '1.5rem' }}>
      <H3>Großmeister G7-G8</H3>
      <Paragraph>
        Verliehen für außerordentliche Verdienste. Der einzige aktuelle Großmeister des Systems ist
        sein Gründer, <Route href={RoutePath.AlexanderSolovev}>Alexander Solovev</Route>.
      </Paragraph>
    </Container>
  </SectionDark1>
);

export default memo(Pyramide);
